// extracted by mini-css-extract-plugin
export var active = "_br-7";
export var container = "_br-0";
export var evenWidth = "_br-4";
export var large = "_br-5";
export var outlet = "_br-8";
export var slide = "_br-2";
export var small = "_br-6";
export var tab = "_br-3";
export var tabs = "_br-1";